import React from "react";
import {
  Grid,
  TextField,
  Container,
  Button,
  Paper,
  CssBaseline,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  InputAdornment
} from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { nb } from "date-fns/locale";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import * as premiumUtils from "./PremiumUtils";
import CurrencyInput from "../common/CurrencyInput";
import { toast } from "react-toastify";
import { withParams } from "../common/WithParams";

class PremiumDetailAdmin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      membership: "",
      premium: {},
      allPremiums: [],
      ownerships: [],
      newOwnership: {},
      ownership: {},
      membersbyOrg: [],
      openNew: false,
      openEdit: false,
      error: "",
      errorNew: {},
      errorEdit: {},
      tffCodes: [],
      selectedTffCode: {},
      reportedByCompanyName: ""
    };
  }

  async componentDidMount() {
    await this.fetchData();

  }


  fetchData = async () => {
    try {
      const membership = this.props.params.org?.toUpperCase();
      const companyId = this.props.params.companyId;
      const year = this.props.params.year;

      if (!membership || !companyId) {
        console.error("Missing required route parameters.");
        return;
      }

      const membersByOrg = await premiumUtils.fetchMembersByOrg(membership)
      const company = await premiumUtils.fetchCompany(companyId);
      const tffCodes = company?.codeTFF || [];

      const mainTffCode = tffCodes.find(c => c.mainCode)?.code;

      const existingPremiumData = await premiumUtils.fetchExistingPremium(
        membership,
        year || "",
        companyId,
        membership === "TFF" ? (mainTffCode || tffCodes[0]?.code) : undefined
      );

      const {
        existingPremium,
        prizeId,
        existingAmount,
        relevantYear,
        ownerships,
        allPremiums
      } = existingPremiumData || {};

      this.setState({
        membership,
        user: { companyId, companyName: company?.companyName || "Ukjent" },
        premium: existingPremium
          ? {
            prizeId: prizeId,
            amount: existingAmount ?? "",
            prizeYear: relevantYear,
            orgMemId: company?.companyId,
            reportedCodeTff: mainTffCode || tffCodes[0]?.code,
          }
          : premiumUtils.setDefaultPremium(company),
        allPremiums,
        reportedByCompanyName: company?.companyName || "Ukjent",
        ownerships: ownerships || [],
        inputDisabled: !existingPremium,
        memberstatus: membership === "YFF"
          ? company?.yffStatusName
          : company?.tffStatusName,
        insurancetype: membership === "YFF"
          ? "yrkesskadeforsikring"
          : "trafikkforsikring",
        tffCodes: company?.codeTFF || [],
        membersbyOrg: membersByOrg || [],
      });
    } catch (error) {
      console.error("Error in fetchData:", error);
    }
  };


  onChange = (e) => {
    const { name, value } = e.target;
    const { allPremiums, premium } = this.state;

    const updatedPremium = { ...premium, [name]: value };

    if (name === "reportedCodeTff") {
      const match = allPremiums.find(p => Number(p.codeTFF) === Number(value));

      if (match) {
        updatedPremium.amount = match.amount;
        updatedPremium.prizeId = match.prizeId;
        updatedPremium.prizeYear = match.prizeYear;
        updatedPremium.locked = match.locked;
      } else {
        updatedPremium.amount = -1;
        updatedPremium.prizeId = -1;
        updatedPremium.locked = true;
      }
    }

    this.setState({ premium: updatedPremium, error: "" });
  };

  onSave = async (event) => {
    event.preventDefault();

    const { valid, error, newAmount } = premiumUtils.formIsValid(
      this.state.premium,
      "update"
    );
    await this.setState({ error });
    if (!valid) return;

    // eslint-disable-next-line react/no-direct-mutation-state
    this.state.premium.amount = newAmount;

    const updatedPremium = {
      ...this.state.premium,
      reportedCodeTff: parseInt(this.state.premium.reportedCodeTff, 10),
      amount: newAmount,
    };

    const saveSuccess = await premiumUtils.savePremium(
      updatedPremium,
      "update"
    );
    if (saveSuccess) {
      await this.fetchData();
    } else {
      console.error("Update operation failed.");
    }
  };

  handleTransferPremium = async (prizeId) => {
    const targetCode = this.state.selectedTffCode[prizeId];
    if (!targetCode) {
      console.warn("Ingen TFF-kode valgt for overføring.");
      return;
    }

    const success = await premiumUtils.transferPremiumToCodeAndHandle(prizeId, this.state.premium.prizeYear, targetCode);

    if (success) {
      await this.fetchData();
    }
  };

  toggleDialog = (dialogType, isOpen, data = null) => {
    this.setState(premiumUtils.toggleDialog(dialogType, isOpen, data));
  };

  handleInputChange = (field, value, ownershipType = "newOwnership", errorField = null) => {
    this.setState(premiumUtils.handleInputChange(field, value, ownershipType, errorField, this.state));
  };

  handleSaveDialog = async (ownershipType = "newOwnership") => {
    const result = await premiumUtils.handleSaveDialog(ownershipType, this.state);
    if (!result.success) {
      if (result.errorNew) {
        this.setState({ errorNew: result.errorNew });
      }
      if (result.errorEdit) {
        this.setState({ errorEdit: result.errorEdit });
      }
      toast.error("Det skjedd noe feil...");
    } else {
      const { fetchOwnerships, newOwnership, openNew, openEdit } = result;

      this.setState({
        ...(fetchOwnerships && { ownerships: fetchOwnerships }),
        ...(newOwnership && { newOwnership }),
        ...(openNew !== undefined && { openNew }),
        ...(openEdit !== undefined && { openEdit }),
      });

      toast.success(`Eierskap er ${ownershipType === "newOwnership" ? "opprettet" : "oppdatert"}`);
    }
  };

  getAmountInt = () => {
    const raw = this.state.premium.amount;
    if (typeof raw !== "string") return parseInt(raw || 0, 10);
    return parseInt(raw.replace(/\s/g, ""), 10);
  };

  render() {
    const root = {
      width: "100%",
    };
    const layout = { width: "100%", paddingTop: 80 };
    const paper = { paddingLeft: 30, paddingTop: 20, paddingRight: 30, paddingBottom: 50 };
    const gridPaddingTop = { paddingTop: 20 };
    const head = { backgroundColor: "#eeeeee", fontWeight: "bold", fontSize: 16, textDecoration: "none" };
    const formcontrolselect = { minWidth: "100%" };
    const smallLabelStyle = {
      fontSize: "12px",
      color: "rgba(0, 0, 0, 0.6)",
    };
    const NOKPrefix = <span style={{ fontSize: "16px" }}>NOK</span>;
    const formatDate = (dateString) => {
      if (!dateString) return "";
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    };
    const hasMarketShareOnly = this.state.allPremiums?.some(p => p.amount < 0);

    return (
      <Container maxWidth="lg">
        <form onSubmit={this.onSave}>
          <main style={layout}>
            <Paper style={paper}>
              <CssBaseline />
              <Grid container spacing={4}>
                <Grid item lg={5}>
                  <h2>
                    {this.state.premium.prizeYear
                      ? `Registrert ${this.state.membership} premie for ${this.state.premium.prizeYear}`
                      : `Registrert ${this.state.membership} premie`}
                  </h2>
                  <Grid style={gridPaddingTop}>
                    <TextField
                      label="Medlem"
                      variant="standard"
                      value={
                        this.state.reportedByCompanyName +
                        " (" +
                        this.state.membership +
                        ")" || ""
                      }
                      fullWidth
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>
                  <Grid style={gridPaddingTop}>
                    <TextField
                      label="År"
                      variant="standard"
                      value={this.state.premium.prizeYear || ""}
                      fullWidth
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>

                  {this.state.membership === "TFF" && (
                    <Grid style={gridPaddingTop}>
                      <FormControl style={formcontrolselect} fullWidth>
                        {this.state.tffCodes.length === 1 ? (
                          <TextField
                            name="reportedCodeTff"
                            label="TFF Kode"
                            value={this.state.tffCodes[0]?.code || ""}
                            fullWidth
                            variant="standard"
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        ) : (
                          <TextField
                            select
                            name="reportedCodeTff"
                            label="TFF Kode"
                            value={this.state.premium.reportedCodeTff ?? ""}
                            onChange={this.onChange}
                            fullWidth
                            variant="standard"
                            SelectProps={{
                              native: true,
                            }}
                          >
                            {this.state.tffCodes.map((codeObj) => (
                              <option key={codeObj.code} value={codeObj.code}>
                                {codeObj.code} {codeObj.mainCode ? "(Hovedkode)" : ""}
                              </option>
                            ))}
                          </TextField>
                        )}
                      </FormControl>
                      {(() => {
                        const mainCodeCount = this.state.tffCodes.filter(c => c.mainCode).length;
                        if (mainCodeCount > 1) {
                          return (
                            <Typography variant="body2" color="error" style={{ paddingTop: 8 }}>
                              Mer enn én hovedkode registrert, handling kreves
                            </Typography>
                          );
                        }
                        if (mainCodeCount === 0 && this.state.tffCodes.length > 0) {
                          return (
                            <Typography variant="body2" color="error" style={{ paddingTop: 8 }}>
                              Ingen hovedkode registrert, handling kreves
                            </Typography>
                          );
                        }
                        return null;
                      })()}
                      <FormHelperText>Velg TFF kode å registrere premie for</FormHelperText>
                    </Grid>
                  )}

                  <Grid item style={gridPaddingTop}>
                    <div>
                      <Typography variant="caption" style={smallLabelStyle}>
                        Opptjent premie
                      </Typography>
                      <div>
                        <CurrencyInput
                          ref={this.currencyInputRef}
                          name="amount"
                          InputProps={{
                            startAdornment:
                              !hasMarketShareOnly &&
                                this.getAmountInt() >= 0 &&
                                this.state.premium.amount !== undefined &&
                                this.state.premium.amount !== null ? (
                                <InputAdornment position="start">{NOKPrefix}</InputAdornment>
                              ) : null,
                          }}
                          placeholder={
                            hasMarketShareOnly
                              ? "Ingen registrert premie, kun markedsandel"
                              : this.getAmountInt() < 0
                                ? "Ingen tidligere premier"
                                : ""
                          }
                          type="text"
                          value={
                            this.state.premium.amount !== undefined &&
                              this.state.premium.amount !== null &&
                              this.getAmountInt() >= 0
                              ? String(this.state.premium.amount)
                              : ""
                          }
                          onChange={this.onChange}
                          disabled={
                            this.state.inputDisabled ||
                            this.state.premium.locked ||
                            this.state.memberstatus !== "Aktiv" ||
                            this.getAmountInt() < 0
                          }
                          style={{
                            position: "relative",
                            top: "1px",
                          }}
                        />
                      </div>
                      <FormHelperText>
                        {`Opptjent premie i ${this.getAmountInt() === -1
                          ? "foregående år"
                          : this.state.premium.prizeYear || "foregående år"
                          } for lovpålagt 
                            ${this.state.insurancetype} (i hele norske kroner). 
                            Direkte norsk forretning uten fradrag av reassuranse${this.state.membership === "TFF" ? " og uten TFA" : ""
                          }.`}
                      </FormHelperText>
                    </div>
                    <Typography style={{ color: "red" }}>{this.state.error.amount}</Typography>
                  </Grid>
                  <Grid style={{ paddingTop: 40 }}>
                    <Button startIcon={<SaveIcon />} type="submit" variant="contained" color="primary">
                      Lagre
                    </Button>
                  </Grid>
                </Grid>

                {/* Ownerships Section */}
                <Grid item lg={7}>
                  <h2>Opprinnelse og eierskap</h2>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => this.toggleDialog("openNew", true)}
                    startIcon={<AddIcon />}
                  >
                    Ny
                  </Button>

                  <Dialog
                    open={this.state.openNew || this.state.openEdit}
                    onClose={() =>
                      this.toggleDialog(this.state.openNew ? "openNew" : "openEdit", false)
                    }
                    fullWidth
                  >
                    <DialogTitle>
                      {this.state.openNew ? "Ny eierskap" : "Rediger eierskap"}
                    </DialogTitle>

                    <DialogContent>
                      <FormControl style={formcontrolselect}>
                        <InputLabel>Eier</InputLabel>
                        <Select
                          name="ownedByOrgMemId"
                          value={
                            (this.state.openNew
                              ? this.state.newOwnership.ownedByOrgMemId
                              : this.state.ownership.ownedByOrgMemId) || ""
                          }
                          onChange={(e) =>
                            this.handleInputChange(
                              "ownedByOrgMemId",
                              e.target.value,
                              this.state.openNew ? "newOwnership" : "ownership",
                              this.state.openNew ? "errorNew" : "errorEdit"
                            )
                          }
                          disabled={!this.state.openNew}
                        >
                          {this.state.membersbyOrg.map((member, index) => (
                            <MenuItem key={index} value={member.orgMemId}>
                              {`${member.companyName} (${member.organisationName})`}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      <LocalizationProvider dateAdapter={AdapterDateFns} locale={nb}>
                        <DatePicker
                          label="Fra"
                          value={
                            (this.state.openNew
                              ? this.state.newOwnership.fromDate
                              : this.state.ownership.fromDate) || null
                          }
                          onChange={(date) =>
                            this.handleInputChange(
                              "fromDate",
                              date,
                              this.state.openNew ? "newOwnership" : "ownership",
                              this.state.openNew ? "errorNew" : "errorEdit"
                            )
                          }
                          renderInput={(params) => (
                            <TextField {...params} fullWidth margin="normal" />
                          )}
                          disabled={!this.state.openNew}
                        />

                        <DatePicker
                          label="Til"
                          value={
                            (this.state.openNew
                              ? this.state.newOwnership.toDate
                              : this.state.ownership.toDate) || null
                          }
                          onChange={(date) =>
                            this.handleInputChange(
                              "toDate",
                              date,
                              this.state.openNew ? "newOwnership" : "ownership",
                              this.state.openNew ? "errorNew" : "errorEdit"
                            )
                          }
                          renderInput={(params) => (
                            <TextField {...params} fullWidth margin="normal" />
                          )}
                        />
                      </LocalizationProvider>

                      <Typography style={{ color: "red" }}>
                        {(this.state.openNew
                          ? this.state.errorNew?.toDate
                          : this.state.errorEdit?.toDate) || ""}
                      </Typography>
                    </DialogContent>

                    <DialogActions>
                      <Button
                        onClick={() =>
                          this.toggleDialog(this.state.openNew ? "openNew" : "openEdit", false)
                        }
                        color="primary"
                      >
                        Avbryt
                      </Button>
                      <Button
                        onClick={() =>
                          this.handleSaveDialog(this.state.openNew ? "newOwnership" : "ownership")
                        }
                        color="primary"
                      >
                        Lagre
                      </Button>
                    </DialogActions>
                  </Dialog>

                  {/* Ownership Table */}
                  <Paper>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell style={head}>Rediger</TableCell>
                          <TableCell style={head}>Navn</TableCell>
                          <TableCell style={head}>Fra</TableCell>
                          <TableCell style={head}>Til</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.ownerships.length > 0 ? (
                          this.state.ownerships.map((ownership, index) => (
                            <TableRow key={index}>
                              <TableCell>
                                <Button
                                  variant="outlined"
                                  color="primary"
                                  onClick={() => this.toggleDialog("openEdit", true, ownership)}
                                  startIcon={<EditIcon />}
                                >
                                  Rediger
                                </Button>
                              </TableCell>
                              <TableCell>{ownership.ownedByCompanyName}</TableCell>
                              <TableCell>{formatDate(ownership.fromDate)}</TableCell>
                              <TableCell>{formatDate(ownership.toDate)}</TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={4}>
                              <Typography align="center">Ingen eierskap</Typography>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </Paper>
                </Grid>

                {/* Premium by TFF code Table */}
                {this.state.membership === "TFF" && (
                  <Grid item xs={12} style={gridPaddingTop}>
                    <h2>Tidligere registrerte premier</h2>
                    <Paper style={root}>
                      <Table stickyHeader aria-label="registered premiums table">
                        <TableHead>
                          <TableRow>
                            <TableCell style={head}>Rapportert av</TableCell>
                            <TableCell style={head}>TFF Kode</TableCell>
                            <TableCell style={head}>Handling</TableCell>
                            <TableCell style={head}>År</TableCell>
                            <TableCell style={head}>
                              {hasMarketShareOnly ? "Markedsandel" : "Beløp (NOK)"}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {this.state.allPremiums && this.state.allPremiums.length > 0 ? (

                            <>
                              {/* Total row */}
                              <TableRow>
                                <TableCell style={{ fontWeight: "bold" }}>
                                  Total sum registrert for Risikobærer
                                </TableCell>
                                <TableCell style={{ fontWeight: "bold" }}>
                                  -----
                                </TableCell>
                                <TableCell style={{ fontWeight: "bold" }}>
                                  -----
                                </TableCell>
                                <TableCell style={{ fontWeight: "bold" }}>
                                  {this.state.premium.prizeYear}
                                </TableCell>
                                <TableCell style={{ fontWeight: "bold" }}>
                                  {this.state.allPremiums
                                    .filter(p => typeof p.amount === "number" && p.amount >= 0)
                                    .reduce((sum, p) => sum + p.amount, 0)
                                    .toLocaleString("nb-NO")}
                                </TableCell>
                              </TableRow>

                              {/* Individual premium rows */}
                              {[...this.state.allPremiums]
                                .sort((a, b) => Number(a.codeTFF) - Number(b.codeTFF))
                                .map((p) => {
                                  const availableCodes = this.state.tffCodes.filter(
                                    (codeObj) => Number(codeObj.code) !== Number(p.codeTFF)
                                  );

                                  return (
                                    <TableRow key={p.prizeId}>
                                      <TableCell>{p.reportedByCompanyName}</TableCell>
                                      <TableCell>
                                        {p.codeTFF}
                                        {this.state.tffCodes.find(
                                          (c) => Number(c.code) === Number(p.codeTFF) && c.mainCode
                                        )
                                          ? " (Hovedkode)"
                                          : ""}
                                      </TableCell>
                                      <TableCell>
                                        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                          <Select
                                            value={this.state.selectedTffCode[p.prizeId] ?? ""}
                                            onChange={(e) => {
                                              const selectedValue = e.target.value;
                                              this.setState((prev) => ({
                                                selectedTffCode: {
                                                  ...prev.selectedTffCode,
                                                  [p.prizeId]: selectedValue,
                                                },
                                              }));
                                            }}
                                            displayEmpty
                                            variant="standard"
                                            native
                                            disabled={availableCodes.length === 0}
                                            style={{ minWidth: "100px" }}
                                          >
                                            <option value="">Velg kode</option>
                                            {this.state.tffCodes
                                              .filter((codeObj) => Number(codeObj.code) !== Number(p.codeTFF))
                                              .map((codeObj) => (
                                                <option key={codeObj.code} value={codeObj.code}>
                                                  {codeObj.code} {codeObj.mainCode ? "(Hovedkode)" : ""}
                                                </option>
                                              ))}
                                          </Select>
                                          <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            onClick={() => this.handleTransferPremium(p.prizeId)}
                                            disabled={
                                              availableCodes.length === 0 || !this.state.selectedTffCode[p.prizeId]
                                            }
                                          >
                                            Overfør
                                          </Button>
                                        </div>
                                      </TableCell>
                                      <TableCell>{p.prizeYear}</TableCell>
                                      <TableCell>
                                        {p.amount >= 0
                                          ? Number(p.amount).toLocaleString("nb-NO")
                                          : p.percentShare != null
                                            ? `${(p.percentShare).toFixed(4).replace(".", ",")} %`
                                            : "N/A"}
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                            </>
                          ) : (
                            <TableRow>
                              <TableCell colSpan={4} align="center">
                                Ingen registrerte premier
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </Paper>
                  </Grid>
                )}
              </Grid>
            </Paper>
          </main>
        </form>
      </Container>
    );
  }
}

export default withParams(PremiumDetailAdmin);
